import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Camada_1"
    data-name="Camada 1"
    viewBox="0 0 986.55 401.41"
    {...props}
  >
    <defs id="defs4">
      <style id="style2">{".cls-1{fill:#fff}"}</style>
    </defs>
    <title id="title6">{"Prancheta 6"}</title>
    <g id="g907">
      <path
        id="path8"
        d="M140.17 315.87a8.1 8.1 0 0 0-8.1-8.1H96.69v8.1a8.1 8.1 0 0 0 8.1 8.11h35.38v-7.67c-.01-.15 0-.31 0-.44Z"
        className="cls-1"
      />
      <path
        id="path10"
        d="M493.37 195.1v52.13H470.6V96h22.77v10.23q16.5-19.37 38.38-19.36a62.51 62.51 0 0 1 62.58 62.58 62.6 62.6 0 0 1-62.58 62.69q-21.89 0-38.38-17.04Zm0-54.45v17.71q2.08 10.45 10.67 18.92a39.27 39.27 0 0 0 67-27.83 39.2 39.2 0 0 0-67-27.71q-8.58 8.46-10.67 18.91Z"
        className="cls-1"
      />
      <path
        id="path12"
        d="M640.54 183.55q5.72 5.05 20.78 5.06a38.11 38.11 0 0 0 27.83-11.44q1.43-1.54 5.83-6.82l22.77 8.14q-8.37 11.55-12.1 15.29a60.42 60.42 0 0 1-44.33 18.36q-25.85 0-44.21-18.36a60.4 60.4 0 0 1-18.37-44.33 60.37 60.37 0 0 1 18.37-44.32q18.36-18.37 44.21-18.37 22.21 0 38.94 13.42 2.75 2.31 5.39 4.95 1.1 1.09 6.27 6.93l-11.44 11.55Zm38.05-70.39q-3.86-3-17.27-3a39.23 39.23 0 0 0-39.15 39.26q0 13.32 3 17.27Z"
        className="cls-1"
      />
      <path
        id="path14"
        d="M819.23 103.81V33.2h22.88v176h-22.88v-14.1q-16.5 17-38.38 17a62.6 62.6 0 0 1-62.58-62.69 60.47 60.47 0 0 1 18.31-44.32 60.2 60.2 0 0 1 44.27-18.37q21.89.04 38.38 17.09Zm0 54.11v-16.83q-2-10.67-10.67-19.35a39.24 39.24 0 0 0-67 27.71 39.27 39.27 0 0 0 67 27.72q8.7-8.68 10.67-19.25Z"
        className="cls-1"
      />
      <path
        id="path16"
        d="M880.48 46.94a15.94 15.94 0 0 1 4.94 11.85 15.94 15.94 0 0 1-4.94 11.85 16.38 16.38 0 0 1-11.86 4.83 16.21 16.21 0 0 1-11.73-4.83 15.91 15.91 0 0 1-4.95-11.85 15.91 15.91 0 0 1 4.95-11.85 16.18 16.18 0 0 1 11.73-4.84 16.35 16.35 0 0 1 11.86 4.84Zm.11 43.83v118.4h-23.82V90.77Z"
        className="cls-1"
      />
      <path
        id="path18"
        d="M921.9 106.77q13.33-18.06 32.79-19v24.74q-13 .69-20.71 8.4a38.86 38.86 0 0 0-12.08 27.39v60.86h-23.82V90.77h23.82Z"
        className="cls-1"
      />
      <path
        id="path20"
        d="M360.1 106.78V99H383v151.2h-22.9v-52.13q-16.5 17-38.39 17a60.2 60.2 0 0 1-44.26-18.36 60.5 60.5 0 0 1-18.32-44.33 62.53 62.53 0 0 1 62.58-62.58q21.9.04 38.39 16.98Zm0 54.11v-16.83q-2-10.67-10.67-19.35a39.24 39.24 0 0 0-67 27.71 39.27 39.27 0 0 0 67 27.83q8.69-8.68 10.67-19.36Z"
        className="cls-1"
      />
      <path
        id="path22"
        d="M425 114q13.35-18.06 32.79-19v24.73q-13 .69-20.71 8.4A38.88 38.88 0 0 0 425 155.57v60.87h-23.84V98H425Z"
        className="cls-1"
      />
      <g
        id="text32"
        aria-label="menu digital"
        style={{
          fontSize: "95.16819px",
          fontFamily: "AcuminPro-Regular,&quot",
          fill: "#fff",
          strokeWidth: 0.98192519,
        }}
        transform="scale(.9916 1.00847)"
      >
        <path
          id="path858"
          d="M407.328 289.914q3.206-5.762 7.667-8.504 4.461-2.741 10.502-2.741 8.132 0 12.547 5.715 4.414 5.67 4.414 16.171v31.413h-8.597v-31.134q0-7.481-2.648-11.106-2.65-3.624-8.086-3.624-6.645 0-10.502 4.414-3.857 4.415-3.857 12.036v29.414h-8.597v-31.134q0-7.528-2.648-11.106-2.649-3.624-8.179-3.624-6.552 0-10.409 4.46-3.857 4.415-3.857 11.99v29.414h-8.597v-52.045h8.597v8.086q2.928-4.786 7.017-7.063 4.09-2.277 9.712-2.277 5.67 0 9.62 2.88 3.995 2.882 5.9 8.365z"
          style={{
            fontSize: "95.16819px",
            fontFamily: "AcuminPro-Regular,&quot",
            fill: "#fff",
            strokeWidth: 0.98192519,
          }}
        />
        <path
          id="path860"
          d="M504.076 303.808v4.182h-39.313q.558 8.83 5.298 13.476 4.786 4.6 13.29 4.6 4.925 0 9.526-1.207 4.647-1.209 9.2-3.625v8.086q-4.6 1.951-9.433 2.974-4.832 1.022-9.805 1.022-12.453 0-19.749-7.25-7.249-7.248-7.249-19.609 0-12.779 6.877-20.26 6.924-7.528 18.634-7.528 10.502 0 16.59 6.784 6.134 6.738 6.134 18.355zm-8.55-2.509q-.093-7.017-3.95-11.199-3.81-4.182-10.13-4.182-7.157 0-11.478 4.043-4.276 4.042-4.926 11.384z"
          style={{
            fontSize: "95.16819px",
            fontFamily: "AcuminPro-Regular,&quot",
            fill: "#fff",
            strokeWidth: 0.98192519,
          }}
        />
        <path
          id="path862"
          d="M561.372 300.555v31.413h-8.55v-31.134q0-7.388-2.882-11.06-2.88-3.67-8.643-3.67-6.924 0-10.92 4.414-3.996 4.415-3.996 12.036v29.414h-8.597v-52.045h8.597v8.086q3.067-4.693 7.202-7.017 4.183-2.323 9.62-2.323 8.968 0 13.568 5.576 4.6 5.53 4.6 16.31z"
          style={{
            fontSize: "95.16819px",
            fontFamily: "AcuminPro-Regular,&quot",
            fill: "#fff",
            strokeWidth: 0.98192519,
          }}
        />
        <path
          id="path864"
          d="M577.636 311.43v-31.507h8.55v31.18q0 7.39 2.881 11.107 2.881 3.671 8.643 3.671 6.924 0 10.92-4.415 4.043-4.414 4.043-12.035v-29.508h8.55v52.045h-8.55v-7.992q-3.113 4.74-7.249 7.063-4.089 2.277-9.526 2.277-8.968 0-13.615-5.576-4.647-5.577-4.647-16.31zm21.515-32.761z"
          style={{
            fontSize: "95.16819px",
            fontFamily: "AcuminPro-Regular,&quot",
            fill: "#fff",
            strokeWidth: 0.98192519,
          }}
        />
        <path
          id="path866"
          d="M703.474 287.823v-28.16h8.55v72.305h-8.55v-7.806q-2.696 4.647-6.831 6.924-4.09 2.23-9.852 2.23-9.433 0-15.381-7.528-5.902-7.528-5.902-19.796 0-12.267 5.902-19.795 5.948-7.528 15.381-7.528 5.762 0 9.852 2.277 4.135 2.23 6.83 6.877zm-29.136 18.17q0 9.433 3.856 14.823 3.904 5.344 10.688 5.344 6.785 0 10.688-5.344 3.904-5.39 3.904-14.824 0-9.433-3.904-14.777-3.903-5.39-10.688-5.39-6.784 0-10.688 5.39-3.856 5.344-3.856 14.777z"
          style={{
            fontSize: "95.16819px",
            fontFamily: "AcuminPro-Regular,&quot",
            fill: "#fff",
            strokeWidth: 0.98192519,
          }}
        />
        <path
          id="path868"
          d="M729.636 279.923h8.55v52.045h-8.55zm0-20.26h8.55v10.827h-8.55z"
          style={{
            fontSize: "95.16819px",
            fontFamily: "AcuminPro-Regular,&quot",
            fill: "#fff",
            strokeWidth: 0.98192519,
          }}
        />
        <path
          id="path870"
          d="M790.277 305.342q0-9.294-3.857-14.406-3.81-5.111-10.734-5.111-6.877 0-10.734 5.111-3.81 5.112-3.81 14.406 0 9.247 3.81 14.359 3.857 5.111 10.734 5.111 6.924 0 10.734-5.111 3.857-5.112 3.857-14.36zm8.55 20.167q0 13.29-5.9 19.75-5.902 6.505-18.077 6.505-4.508 0-8.504-.697-3.996-.65-7.76-2.045v-8.317q3.764 2.044 7.435 3.02 3.67.976 7.481.976 8.41 0 12.593-4.415 4.182-4.368 4.182-13.243v-4.229q-2.648 4.6-6.784 6.877-4.136 2.277-9.898 2.277-9.573 0-15.428-7.295-5.855-7.296-5.855-19.331 0-12.082 5.855-19.378 5.855-7.295 15.428-7.295 5.762 0 9.898 2.277t6.784 6.877v-7.9h8.55z"
          style={{
            fontSize: "95.16819px",
            fontFamily: "AcuminPro-Regular,&quot",
            fill: "#fff",
            strokeWidth: 0.98192519,
          }}
        />
        <path
          id="path872"
          d="M816.44 279.923h8.55v52.045h-8.55zm0-20.26h8.55v10.827h-8.55z"
          style={{
            fontSize: "95.16819px",
            fontFamily: "AcuminPro-Regular,&quot",
            fill: "#fff",
            strokeWidth: 0.98192519,
          }}
        />
        <path
          id="path874"
          d="M851.29 265.146v14.777h17.613v6.645H851.29v28.253q0 6.367 1.72 8.179 1.765 1.812 7.109 1.812h8.783v7.156h-8.783q-9.898 0-13.662-3.67-3.764-3.718-3.764-13.477v-28.253h-6.273v-6.645h6.273v-14.777z"
          style={{
            fontSize: "95.16819px",
            fontFamily: "AcuminPro-Regular,&quot",
            fill: "#fff",
            strokeWidth: 0.98192519,
          }}
        />
        <path
          id="path876"
          d="M903.847 305.806q-10.362 0-14.359 2.37-3.996 2.37-3.996 8.086 0 4.554 2.974 7.25 3.02 2.648 8.179 2.648 7.11 0 11.384-5.019 4.322-5.065 4.322-13.43v-1.905zm17.054-3.531v29.693h-8.55v-7.9q-2.928 4.74-7.296 7.018-4.368 2.23-10.687 2.23-7.993 0-12.733-4.461-4.693-4.507-4.693-12.035 0-8.783 5.855-13.244 5.901-4.461 17.565-4.461h11.989v-.836q0-5.902-3.903-9.108-3.857-3.253-10.874-3.253-4.461 0-8.69 1.069-4.228 1.068-8.132 3.206v-7.9q4.694-1.812 9.108-2.695 4.415-.93 8.597-.93 11.292 0 16.868 5.856 5.576 5.855 5.576 17.75z"
          style={{
            fontSize: "95.16819px",
            fontFamily: "AcuminPro-Regular,&quot",
            fill: "#fff",
            strokeWidth: 0.98192519,
          }}
        />
        <path
          id="path878"
          d="M938.56 259.663h8.55v72.305h-8.55z"
          style={{
            fontSize: "95.16819px",
            fontFamily: "AcuminPro-Regular,&quot",
            fill: "#fff",
            strokeWidth: 0.98192519,
          }}
        />
      </g>
      <path
        id="path34"
        d="M207.07 71.28h-3.72V40.11a8.11 8.11 0 0 0-9.06-8.19L28.79 51.63a8.1 8.1 0 0 0-7.14 8v295.61a8.14 8.14 0 0 0 8.14 8.15h115.82V354.6a8.1 8.1 0 0 0-8.07-7.41H37.89V87.53H199v143h8.79a8.1 8.1 0 0 0 7.42-8.07v-143a8.15 8.15 0 0 0-8.14-8.18Zm-20 0H37.89v-4.37L187.05 49.1Z"
        className="cls-1"
      />
      <path
        id="path36"
        d="M325.36 347.19h-11.61v-14.68h11.61a8.1 8.1 0 0 0 8.1-8.1 87.06 87.06 0 0 0-78.83-86.56v-14a8.1 8.1 0 1 0-16.2 0v14a87.06 87.06 0 0 0-78.83 86.56 8.1 8.1 0 0 0 8.1 8.1h11.61v14.68H167.7a8.1 8.1 0 0 0-8.1 8.1v8.1h165.76a8.1 8.1 0 0 0 8.09-7.79v-8.41Zm-27.81 0h-102v-14.68h102Zm-121.29-30.88a70.74 70.74 0 0 1 140.54 0Z"
        className="cls-1"
      />
      <path
        id="path38"
        d="M79.7 167.73v27.84a5.78 5.78 0 0 0 5.78 5.79h27.85a5.79 5.79 0 0 0 5.79-5.79v-27.84a5.79 5.79 0 0 0-5.79-5.79H85.48a5.78 5.78 0 0 0-5.78 5.79Zm0 0"
        className="cls-1"
      />
      <path
        id="path40"
        d="M148.79 175.25v14.53h-14a5.79 5.79 0 1 0 0 11.58h19.74a5.79 5.79 0 0 0 5.79-5.79v-20.32a5.79 5.79 0 1 0-11.57 0Zm0 0"
        className="cls-1"
      />
      <path
        id="path42"
        d="M79.7 124.39v27.85a5.78 5.78 0 0 0 5.78 5.76h27.85a5.79 5.79 0 0 0 5.79-5.79v-27.82a5.78 5.78 0 0 0-5.79-5.78H85.48a5.78 5.78 0 0 0-5.78 5.78Zm27.84 5.79v16.28H91.27v-16.28Zm0 0"
        className="cls-1"
      />
      <path
        id="path44"
        d="M129.2 130.06v16.51a5.79 5.79 0 0 0 5.79 5.79h16.5a5.79 5.79 0 0 0 5.78-5.79v-16.51a5.79 5.79 0 0 0-5.78-5.79H135a5.79 5.79 0 0 0-5.79 5.79Zm0 0"
        className="cls-1"
      />
    </g>
  </svg>
)
export default SvgComponent
